<div [formGroup]="form" class="grid gap-6">
    <mat-radio-group formControlName="type" class="flex flex-col gap-2">
        <mat-radio-button value="Gift">Gjöf</mat-radio-button>
        <mat-radio-button value="Invitation">Boð</mat-radio-button>
        <mat-radio-button value="Travel">Starfstengd boðsferð</mat-radio-button>
    </mat-radio-group>

    <mat-form-field appearance="fill">
        <mat-label>Hver gefur/býður?</mat-label>
        <input matInput formControlName="offeredBy" />
        <mat-error>Þessi reitur er skyldureitur</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Lýsing á gjöf/boði</mat-label>
        <textarea matInput rows="6" formControlName="description"></textarea>
        <mat-hint align="end">{{ form.get('description')?.value?.length ?? 0 }}/2000</mat-hint>
        <mat-error>Lýsing er skyldureitur</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Dagsetning</mat-label>
        <input matInput class="date" formControlName="date" (click)="date.open()" [matDatepicker]="date" />
        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
        <mat-error>Dagsetning er skyldureitur</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Áætlað verðmæti</mat-label>
        <input matInput maxlength="11" numericFormat formControlName="estimatedValue" />
        <span matSuffix>kr.</span>
        <mat-hint>Skal miða við samanlagt verðmæti frá sama aðila á ársgrundvelli.</mat-hint>
    </mat-form-field>
</div>
